module.exports = __webpack_public_path__ + "static/media/fish.8581d8af.JPG";